<template>
  <modal :show="show" @close="close">
    <v-flex class="ma-1" slot="title">{{ id ? 'Edytuj kartę' : 'Dodaj kartę' }}</v-flex>

    <div>
      <v-layout column>
        <v-text-field v-model="cardOwner" name="name" readonly :label="$schema.profileId.$title" />

        <w-select :model="$schema.state" :label="$schema.state.$title" :items="statuses" />

        <v-flex xs6>
          <radio-group :model="$schema.expirationType" :elements="cardExpirationTypes" />
        </v-flex>

        <v-flex xs6>
          <datepicker :schema="$schema.startDate" />
        </v-flex>

        <v-flex xs6>
          <datepicker :schema="$schema.blockEndDate" />
        </v-flex>

        <v-flex v-if="$schema.blockEndDate.$model">
          <w-schema :model="$schema.blockReason">
            <v-textarea name="block-reason" :label="$schema.blockReason.$title" />
          </w-schema>
        </v-flex>

        <v-flex v-if="isInactive">
          <w-schema :model="$schema.inactiveReason">
            <v-textarea name="inactive-reason" :label="$schema.inactiveReason.$title" />
          </w-schema>
        </v-flex>
      </v-layout>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import {
  CardExpirationType,
  CardExpirationTypeTranslation,
  CardState,
  CardStateTranslation
} from '@witkac/kartamiejska-shared';
import { schemaMixin, WSchema, WSelect } from '@witkac/vuetify-components';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';

import RadioGroup from '@/components/forms/RadioGroup';
import Modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/card.schema';

function emptyData() {
  return {
    state: '',
    number: '',
    profileId: null,
    startDate: '',
    expirationType: '',
    blockEndDate: '',
    blockReason: '',
    inactiveReason: ''
  };
}

// @vuese
// Modal dodawnia/edycji karty klienta
// @group Client-Profile
export default {
  schema,
  props: {
    // Id profilu do którego przypisana ma być karta
    profileId: {
      type: Number,
      required: true
    }
  },
  mixins: [manageMixin('client/cards', {}, emptyData), notificationsMixin],
  components: { WSchema, WSelect, Modal, RadioGroup },
  data() {
    return {
      statuses: [
        {
          text: CardStateTranslation[CardState.NOT_CONFIRMED],
          value: CardState[CardState.NOT_CONFIRMED]
        },
        {
          text: CardStateTranslation[CardState.ORDERED],
          value: CardState[CardState.ORDERED]
        },
        {
          text: CardStateTranslation[CardState.PREPARED_TO_PRINT],
          value: CardState[CardState.PREPARED_TO_PRINT]
        },
        {
          text: CardStateTranslation[CardState.PRINTED],
          value: CardState[CardState.PRINTED]
        },
        {
          text: CardStateTranslation[CardState.PREPARED],
          value: CardState[CardState.PREPARED]
        },
        {
          text: CardStateTranslation[CardState.TRANSPORT],
          value: CardState[CardState.TRANSPORT]
        },
        {
          text: CardStateTranslation[CardState.READY],
          value: CardState[CardState.READY]
        },
        {
          text: CardStateTranslation[CardState.ACTIVE],
          value: CardState[CardState.ACTIVE]
        },
        {
          text: CardStateTranslation[CardState.INACTIVE],
          value: CardState[CardState.INACTIVE]
        }
      ]
    };
  },
  methods: {
    // @vuese
    // Ustawia dane formularza
    setData() {
      this.$schema.$setData(this.id ? this.$store.getters['client/cards/byId'](this.id) : emptyData(), undefined, true);

      this.$schema.$reset();
      this.$schema.profileId.$model = this.profileId;
    },
    // @vuese
    // Zapisuje karte
    save() {
      if (!this.$schema.$validateAll().length) {
        const model = this.$schema.$getData();
        if (!this.id) {
          this.$store
            .dispatch('client/cards/add', { ...model })
            .then(() => {
              this.notifySuccess('Dodano kartę');
              this.closeModal();
            })
            .catch(error => this.notifyError(error.message));
        } else {
          this.$store
            .dispatch('client/cards/update', { id: this.id, ...model })
            .then(() => {
              this.notifySuccess('Zapisano kartę');
              this.closeModal();
            })
            .catch(error => this.notifyError(error.message));
        }
      } else {
        this.notifyError('Błędnie wypełniony formularz.');
      }
    }
  },
  computed: {
    isInactive() {
      return this.$schema.state.$model === CardState[CardState.INACTIVE];
    },
    cardExpirationTypes() {
      return Object.keys(CardExpirationType).map(expirationType => ({
        value: CardExpirationType[expirationType],
        text: CardExpirationTypeTranslation[CardExpirationType[expirationType]]
      }));
    },
    ...mapState({
      cardOwner: state => state.client.data.profile.firstName + ' ' + state.client.data.profile.lastName
    })
  }
};
</script>
